import { connect } from 'react-redux';

import { getSamplesSpecificationsTableData } from 'store/scenes/bootstrapCIs/samples/selectors';
import { getPrimaryParameterLevel } from 'store/scenes/bootstrapCIs/primaryParameterLevel/selectors';
import { getPrimaryParameter } from 'store/scenes/bootstrapCIs/primaryParameter/selectors';

import CategoricalComponent from './Component';

const mapStateToProps = state => ({
  primaryParameterLevel: getPrimaryParameterLevel(state),
  primaryParameter: getPrimaryParameter(state).name,
  samplesSpecifications: getSamplesSpecificationsTableData(state)
});

export default connect(mapStateToProps)(CategoricalComponent);
